normalizeReadFieldOptions